import { __awaiter } from "tslib";
import { getLocale } from '../locale';
import request from '../request';
const getSettings = (key, path) => __awaiter(void 0, void 0, void 0, function* () {
    const locale = getLocale();
    // check if storage exists at all
    const settingsInStorage = sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem(`settings_${locale}`);
    // if doesnt exist API
    if (!settingsInStorage) {
        try {
            const settingsValue = yield request.get(path, { apiVersion: 2 });
            // then if no errors create save to storage
            sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.setItem(`settings_${locale}`, JSON.stringify(settingsValue.data));
            // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | null' is not assignable... Remove this comment to see the full error message
            const settings = JSON.parse(sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem(`settings_${locale}`));
            return settings[key];
        }
        catch (error) {
            return undefined;
        }
    }
    else {
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | null' is not assignable... Remove this comment to see the full error message
        const settings = JSON.parse(sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem(`settings_${locale}`));
        return settings[key];
    }
});
export default getSettings;
//# sourceMappingURL=getSettings.js.map